
import { MapPin, Calendar } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { RatingDisplay } from "./RatingDisplay";

interface AddressHeaderProps {
  address: string;
  averageRating: number;
  totalReviews: number;
  rentalYearsRange: string | null;
  displayTitle?: string;
}

export const AddressHeader = ({ 
  address, 
  averageRating, 
  totalReviews,
  rentalYearsRange,
  displayTitle
}: AddressHeaderProps) => {
  const { t, language } = useLanguage();
  
  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-2xl md:text-3xl font-bold break-words">{displayTitle || address}</h1>
      <div className="flex items-center gap-2 text-muted-foreground">
        <MapPin className="h-4 w-4" />
        <span>{address}</span>
      </div>
      {rentalYearsRange && (
        <div className="flex items-center gap-2 text-muted-foreground">
          <Calendar className="h-4 w-4" />
          <span>{rentalYearsRange}</span>
        </div>
      )}
      <RatingDisplay averageRating={averageRating} totalReviews={totalReviews} />
    </div>
  );
};
